import { Link } from "react-router-dom";
import { Megaphone, ArrowLeft } from "lucide-react";
import { StatusBadge } from "@/components/DadStatus";
export default function Marketing() {
 return <section className="dad-marketing" data-testid="marketing-page">
  <Link to="/" className="dad-text-link"><ArrowLeft size={18} /> Organismo</Link>
  <div className="dad-panel"><Megaphone size={32} aria-hidden="true" /><span className="dad-eyebrow">Bocca</span>
   <h1>Marketing & Comunicazione</h1><StatusBadge state="unknown">Area in sviluppo · Dati insufficienti</StatusBadge>
   <p>Il modo in cui l’azienda parla verso l’esterno: comunica, racconta, promuove e attrae.</p>
   <p>Questa area non raccoglie ancora dati e non offre operazioni di pubblicazione.</p>
   <h2>Ambiti previsti</h2><ul><li>Marketing, campagne e promozioni</li><li>Comunicazione aziendale e reputazione</li><li>Sito web, social media e brand</li><li>Contenuti e newsletter</li><li>Comunicazioni verso clienti e mercato</li></ul>
   <p>Clienti, ordini, fatturazione, produzione e servizi rimangono in Respiro.</p>
   <Link to="/sales" className="dad-text-link">Apri Vendite & Operazioni</Link>
  </div>
 </section>;
}
